const actionConst = {
  OPEN_ORG_PARAMS_MODAL: 'OPEN_ORG_PARAMS_MODAL',
  CLOSE_ORG_PARAMS_MODAL: 'CLOSE_ORG_PARAMS_MODAL',
};

export default actionConst